module.exports = __webpack_public_path__ + "static/img/personal-icon1.0ce0e5b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/personal-icon1.png
// module id = lQ0R
// module chunks = 1